import { CellSelect } from './styles';

export default CellSelect;
